import { useNavigate } from "react-router-dom";

const BRAND = "#FF6B35";

interface PaymentHeaderProps {
  orderAmount: number;
  depositAmount: number;
  total: number;
  /** 动态订单描述（如 "别克GL8 · 三亚凤凰机场"），为空时显示默认文案 */
  description?: string;
  loading?: boolean;
}

export function PaymentHeader({ orderAmount, depositAmount, total, description, loading }: PaymentHeaderProps) {
  const navigate = useNavigate();

  return (
    <div
      className="relative overflow-hidden"
      style={{ background: "linear-gradient(145deg,#1A1A2E 0%,#16213E 60%,#0F3460 100%)" }}
    >
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute rounded-full" style={{ width: 160, height: 160, top: -30, right: -10, background: "rgba(255,107,53,0.1)", filter: "blur(30px)" }} />
      </div>
      <div className="relative px-5 pb-5" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 48px)" }}>
        <div className="flex items-center gap-3 mb-5">
          <button
            onClick={() => navigate(-1)}
            className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0"
            style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.15)" }}
          >
            <i className="ri-arrow-left-line" style={{ fontSize: 18, color: "#fff" }} />
          </button>
          <div className="flex items-center gap-2 flex-1">
            <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: "linear-gradient(135deg,#FF6B35,#FF9A5C)" }}>
              <i className="ri-secure-payment-line text-white" style={{ fontSize: 13 }} />
            </div>
            <div>
              <div className="text-sm font-bold text-white leading-tight">确认支付</div>
              <div className="text-xs leading-tight" style={{ color: "rgba(255,255,255,0.45)" }}>美伊旅行 · 安全支付</div>
            </div>
          </div>
        </div>

        {/* Order summary */}
        <div className="rounded-2xl p-4" style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)" }}>
          <div className="text-xs mb-3" style={{ color: "rgba(255,255,255,0.5)" }}>
            {loading ? (
              <span className="inline-block w-48 h-3.5 rounded animate-pulse" style={{ background: "rgba(255,255,255,0.15)" }} />
            ) : (
              description || "美伊旅行 · 安全支付"
            )}
          </div>
          <div className="space-y-2 mb-3">
            <div className="flex items-center justify-between">
              <span className="text-xs" style={{ color: "rgba(255,255,255,0.6)" }}>订单金额</span>
              {loading ? (
                <span className="inline-block w-16 h-4 rounded animate-pulse" style={{ background: "rgba(255,255,255,0.15)" }} />
              ) : (
                <span className="text-sm font-semibold text-white">¥{orderAmount.toLocaleString()}</span>
              )}
            </div>
            {/* <div className="flex items-center justify-between">
              <span className="text-xs flex items-center gap-1" style={{ color: "rgba(255,255,255,0.6)" }}>
                押金金额
                <span className="text-xs px-1.5 py-0.5 rounded-full" style={{ background: "rgba(255,107,53,0.2)", color: "#FF9A5C" }}>可退</span>
              </span>
              <span className="text-sm font-semibold text-white">¥{depositAmount.toLocaleString()}</span>
            </div> */}
            <div className="h-px" style={{ background: "rgba(255,255,255,0.1)" }} />
            <div className="flex items-center justify-between">
              <span className="text-sm font-bold text-white">合计</span>
              <div className="text-right">
                {loading ? (
                  <span className="inline-block w-28 h-8 rounded animate-pulse" style={{ background: "rgba(255,154,92,0.2)" }} />
                ) : (
                  <div className="text-2xl font-bold" style={{ color: "#FF9A5C" }}>¥{total.toLocaleString()}</div>
                )}
              </div>
            </div>
          </div>
          {/* <div className="text-xs px-2 py-1.5 rounded-lg" style={{ background: "rgba(255,107,53,0.15)", color: "rgba(255,210,180,0.9)" }}>
            <i className="ri-information-line mr-1" style={{ fontSize: 11 }} />押金将在行程结束后3个工作日内退还
          </div> */}
        </div>
      </div>
    </div>
  );
}
